@charset "UTF-8";

/* src/app/app.component.scss */
body .ui-panel {
  margin-top: 1.25em;
}
.mat-mdc-menu-item:hover {
  background-color: #2e65a6 !important;
  color: #ffffff !important;
}
.mat-menu-item:hover {
  background-color: #2e65a6 !important;
  color: #ffffff !important;
}
.app-bootstrap-screen {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(
      circle at top,
      rgba(4, 108, 234, 0.14),
      transparent 32%),
    linear-gradient(
      180deg,
      #f6f9ff 0%,
      #eef4fb 100%);
  z-index: 9999;
}
.app-bootstrap-card {
  min-width: 260px;
  max-width: 420px;
  padding: 28px 32px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 18px 55px rgba(3, 20, 48, 0.14);
  backdrop-filter: blur(10px);
  text-align: center;
  color: #012b5d;
}
.app-bootstrap-spinner {
  width: 44px;
  height: 44px;
  margin: 0 auto 18px;
  border: 4px solid rgba(4, 108, 234, 0.16);
  border-top-color: #046cea;
  border-radius: 50%;
  animation: appBootstrapSpin 0.9s linear infinite;
}
.app-bootstrap-title {
  font-size: 1.05rem;
  font-weight: 700;
  margin-bottom: 8px;
}
.app-bootstrap-text {
  font-size: 0.95rem;
  line-height: 1.45;
  color: rgba(1, 22, 46, 0.78);
}
@keyframes appBootstrapSpin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=app.component-6FXPIYVF.css.map */
